import { render, staticRenderFns } from "./TradePanel.vue?vue&type=template&id=8ca740c0&scoped=true"
import script from "./TradePanel.vue?vue&type=script&lang=js"
export * from "./TradePanel.vue?vue&type=script&lang=js"
import style0 from "./TradePanel.vue?vue&type=style&index=0&id=8ca740c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_bddh7bz47tm4asog4nvkp26dru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca740c0",
  null
  
)

export default component.exports